import { Edges } from '@react-three/drei';
import { useAnnotationInk } from '../hooks/useThemeInk';
import { useAppStore } from '../state/store';

/**
 * Theme-aware <Edges> for BIM/3D element silhouettes. In wireframe there
 * are no faces: the strokes sit directly on the theme viewport, so they
 * follow the viewport ink (white on dark, black on light) instead of a
 * hardcoded 'black' that vanished in dark mode. The other display styles
 * show edges against white paper faces (hiddenLine/plan hatch) or shaded
 * bodies — the classic black stays readable in both color modes there.
 * Selection keeps the shared highlight blue.
 */
export function InkEdges({
    isSelected,
    threshold = 15,
    ...rest
}: {
    isSelected: boolean;
    threshold?: number;
    [key: string]: unknown;
}) {
    const ink = useAnnotationInk();
    const viewMode = useAppStore((s) => s.view.viewMode);
    const restingColor = viewMode === 'wireframe' ? ink : 'black';
    return <Edges color={isSelected ? '#00aaff' : restingColor} threshold={threshold} {...rest} />;
}
